import {Injectable} from '@angular/core';
import {IAppConfig} from './app-config';
import {Environment} from "../../config/env";

@Injectable()
export class AppConfigService<T extends IAppConfig> {
  settings: T | undefined;

  async load() {
    const environmentName: string = (Environment.production) ? 'prod' : 'dev';
    const jsonFile = `assets/config/settings.${environmentName}.json`;

    try {
      const response  = await fetch(jsonFile);
      if (!response.ok) {
        throw new Error(`Could not load file '${jsonFile}': ${response.status}`);
      }
      this.settings = await response.json();
    } catch (error: any) {
      console.error(`Could not parse JSON file '${jsonFile}'`);
      console.error(error);
    }
  }
}
